const version = "2.4.6";
const publishDates = {
  major: "2024-06-28T10:56:07.893Z",
  minor: "2024-07-22T16:42:50.301Z",
  patch: "2024-08-29T10:01:17.530Z"
};
export {
  publishDates,
  version
};
//# sourceMappingURL=version.mjs.map
